export const createFocusTrap = (container: HTMLElement, backgroundSelector?: string) => {
    let active = false;
    let background: HTMLElement[] = [];

    const onKeydown = (event: KeyboardEvent) => {
        if (event.key !== 'Tab') return;
        const controls = Array.from(container.querySelectorAll<HTMLElement>(
            'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]'
        )).filter(element => element.tabIndex >= 0 && element.getClientRects().length &&
            !element.closest('[inert]') && getComputedStyle(element).visibility !== 'hidden');
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!first || document.activeElement === (event.shiftKey ? first : last)) {
            event.preventDefault();
            (event.shiftKey ? last : first)?.focus();
        }
    };

    return {
        get active() { return active; },
        activate() {
            if (active) return;
            active = true;
            if (backgroundSelector) {
                background = Array.from(document.querySelectorAll<HTMLElement>(backgroundSelector));
            } else {
                for (let node = container; node.parentElement && node !== document.body; node = node.parentElement) {
                    background.push(...Array.from(node.parentElement.children)
                        .filter((sibling): sibling is HTMLElement => sibling !== node && sibling instanceof HTMLElement));
                }
            }
            background = background.filter(element => !element.inert && !element.contains(container));
            background.forEach(element => { element.inert = true; });
            container.setAttribute('aria-modal', 'true');
            container.addEventListener('keydown', onKeydown);
        },
        release() {
            if (!active) return;
            active = false;
            background.forEach(element => { element.inert = false; });
            background = [];
            container.removeAttribute('aria-modal');
            container.removeEventListener('keydown', onKeydown);
        }
    };
};
